import * as actionTypes from "../../constants/actionTypes";

const resetOfferResultsPagination = () => {
  return {
    type: actionTypes.RESET_OFFER_RESULTS_PAGINATION
  };
};

const updateOfferResultsPagination = currentPage => {
  return {
    type: actionTypes.UPDATE_OFFER_RESULTS_PAGINATION,
    currentPage: currentPage
  };
};

export { resetOfferResultsPagination, updateOfferResultsPagination };
